import InnerComponent from '@Components/Purchase/PurchaseRequests/PurchaseRequestsHome';
import orgContainer from '@Components/AppContainer';

const PurchaseRequestsHome = () => ((orgContainer(InnerComponent)));
export default PurchaseRequestsHome;
